import { IUserProvider, RoleE } from '@/providers/types';

export const configHiddenGhostMode = {
  advertisers: {
    hidden: ['advertiser', 'publisher', 'portal'],
    show: ['feedId', 'publisherId'],
  },
  publishers: {
    hidden: ['publisher', 'gloPublisher', 'gloPubFeed', 'campaign', 'gloPubFeedUrl'],
    show: ['publisherId', 'pubFeedId', 'campaignId'],
  },
  import: {
    hidden: ['name', 'trader', 'advertiser'],
    show: ['id', 'traderId', 'advertiserId'],
  },
  export: {
    hidden: ['name', 'trader', 'publisher'],
    show: ['id', 'traderId', 'publisherId'],
  },
  logs: {
    hidden: ['advertiser', 'gloSrc', 'gloGroup'],
    show: ['advertiserId', 'gloSrcId', 'gloGroupId'],
  },
  campaigns: {
    hidden: ['name', 'parentName', 'feedName', 'filters', 'groups', 'edit'],
    show: ['parentId', 'feedId'],
  },
  tqm: {
    hidden: ['name', 'roi', 'roiPercentage', 'advTitle', 'feedTitle', 'pubTitle', 'createdName', 'edit'],
    show: ['advertiserId', 'feedId', 'publisherId'],
  },
  tqf: {
    hidden: ['name', 'roi', 'roiPercentage', 'createdName', 'edit'],
    show: [],
  },
  volume: {
    hidden: ['name', 'roi', 'roiPercentage', 'createdName', 'edit'],
    show: [],
  },
  protectionRecoup: {
    hidden: ['name', 'roi', 'roiPercentage', 'createdName', 'edit'],
    show: [],
  },
  geoFence: {
    hidden: ['name', 'roi', 'roiPercentage', 'createdName', 'edit'],
    show: [],
  },
  cro: {
    hidden: ['name', 'roi', 'roiPercentage', 'createdName', 'edit'],
    show: [],
  },
  pubFeedsSettings: {
    hidden: [],
    show: [],
  },
  manualPubFeedsEdr: {
    hidden: ['publisher', 'feed'],
    show: [],
  },
  manualAdvFeedsEdr: {
    hidden: ['publisher', 'feed'],
    show: [],
  },
};

const configHiddenCVModeAdmin = {
  import: {
    hiddenCVMode: ['yrevenue', 'mtdRevenue', 'netRoi', 'netRoip', 'yroi', 'yRoiVal'],
    showCVMode: [],
  },
  export: {
    hiddenCVMode: ['roiMtd', 'roiMtdP', 'pubProfitability', 'revMtd'],
    showCVMode: [],
  },
  campaigns: {
    hiddenCVMode: ['rev', 'roi'],
    showCVMode: [],
  },
  logs: {
    hiddenCVMode: ['rev', 'roi'],
    hiddenExportXLSCVMode: ['f[rev]', 'f[roi]'],
    showCVMode: [],
  },
  pubFeedsSettings: {
    hiddenCVMode: ['revMtd', 'roi'],
    showCVMode: [],
  },
};

const configHiddenCVModePub = {
  logs: {
    hiddenCVMode: ['costCpc', 'costCpa'],
    hiddenExportXLSCVMode: ['f[cost_cpc]', 'f[cost_cpa]'],
    showCVMode: [],
  },
};

const configHiddenCVModeAdv = {
  campaigns: {
    hiddenCVMode: ['rev', 'roi'],
    hiddenExportXLSCVMode: [],
    showCVMode: [],
  },
  logs: {
    hiddenCVMode: ['spendCpc'],
    hiddenExportXLSCVMode: ['f[rev_cpc]'],
    showCVMode: [],
  },
};

export const configHiddenCVMode = (user: IUserProvider) => {
  switch (user?.role) {
    case RoleE.ADV:
      return configHiddenCVModeAdv;
    case RoleE.PUB:
      return configHiddenCVModePub;
    default:
      return configHiddenCVModeAdmin;
  }
};

export default configHiddenGhostMode;
